/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ConfigurationDto } from '../models/configuration-dto';

@Injectable({
  providedIn: 'root',
})
export class ConfigurationService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation configurationGetConfiguration
   */
  static readonly ConfigurationGetConfigurationPath = '/api/Configuration/{platform}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `configurationGetConfiguration()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationGetConfiguration$Response(params: {
    platform: null | string;

  }): Observable<StrictHttpResponse<ConfigurationDto>> {

    const rb = new RequestBuilder(this.rootUrl, ConfigurationService.ConfigurationGetConfigurationPath, 'get');
    if (params) {

      rb.path('platform', params.platform, {});

    }
    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ConfigurationDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `configurationGetConfiguration$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  configurationGetConfiguration(params: {
    platform: null | string;

  }): Observable<ConfigurationDto> {

    return this.configurationGetConfiguration$Response(params).pipe(
      map((r: StrictHttpResponse<ConfigurationDto>) => r.body as ConfigurationDto)
    );
  }

}
